import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { POST } from "../../utils/fetchUtil";
import { UserContext } from "../user/UserContext";
import { MessageContext } from "../message";

const Consent = () => {
  const message = useContext(MessageContext);
  const { t } = useTranslation();
  const user = useContext(UserContext);

  const title = `PREDMET: OSOBNI PODACI, INFORMACIJE ČLANOVIMA`;
  const textStart = `

  Hrvatska komora medicinskih sestara (dalje u tekstu: HKMS) sa sjedištem u Zagrebu, Maksimirska 111/II, zastupana po predsjednici/ku temeljem Zakona o sestrinstvu („Narodne novine“ broj: 121/03, 117/08, 57/11) je strukovna samostalna organizacija medicinskih sestara sa svojstvom pravne osobe i javnim ovlastima koja promiče, zastupa i usklađuje interese medicinskih sestara pred državnim i drugim tijelima u Republici Hrvatskoj i u inozemstvu. Temeljem članka 25. Zakona o sestrinstvu sve medicinske sestre te medicinski tehničari koji obavljaju svoju djelatnost obvezno se udružuju u Komoru. 

   Člankom 26. Zakona o sestrinstvu HKMS je određena kao pravna osoba s javnim ovlastima te su navedenim člankom pobliže definirane navedene javne ovlasti na način da su iste:
   – vođenje registra svojih članova,;
   – davanje, obnavljanje i oduzimanje odobrenja za samostalan rad,;
   – obavljanje stručnog nadzora nad radom medicinskih sestara. ;
   U svrhu ostvarivanja navedenih javnih ovlasti kao i provođenja zakonom propisanih postupaka HKMS prikuplja osobne podatke koji se odnose na identitet te podatke o obrazovanju pojedine osobe radi utvrđivanja jesu li ispunjeni uvjeti za pristup reguliranoj profesiji sestrinstva te uspješno vođenje evidencije o našim članovima. 


    HKMS pohranjuje i čuva osobne podatke u materijalnom obliku i u elektronskom obliku pri čemu se isti čuvaju trajno sukladno Pravilniku o zaštiti arhivskog i registraturnog gradiva HKMS. Osobne podatke HKMS koristi isključivo radi ostvarivanja gore navedenih javnih ovlasti te se isti ne mogu staviti na raspolaganje niti učiniti dostupnim drugim fizičkim ili pravnim osobama osim u slučaju postupanja na zahtjev sudova, tijela državne uprave i drugih državnih tijela, tijela jedinica lokalne i područne (regionalne) samouprave, pravnih osoba koje imaju javne ovlasti te drugih osoba u posebnim slučajevima propisanim zakonom. Bilo kakvo raspolaganje osobnim podacima izvan navedenih razloga HKMS može poduzeti jedino na temelju izričite privole i to isključivo radi ostvarivanja posebne svrhe za koju je privola dana. 

  
    U bilo kojem trenutku član HKMS može se obratiti službeniku za zaštitu osobnih podataka HKMS u 
    pogledu svih pitanja povezanih s obradom svojih osobnih podataka i ostvarivanjem svojih prava 
    na temelju pozitivnih propisa. Zainteresirane osobe mogu ostvarivati svoje pravo podnošenjem:

  
    1.    usmenog zahtjeva:
    •	osobno na adresi sjedišta: Hrvatska komora medicinskih sestara, Maksimirska 111/II, 10000 Zagreb
    •	telefonskim putem na broj: 01/2444303 (radnim danom od 8.00 do 16.00 sati)

  
    2.    pisanog zahtjeva:
    •	putem poštanskog ureda uz naznaku „Zahtjev za zaštitu osobnih podataka“ na adresu sjedišta: Hrvatska komora medicinskih sestara, Maksimirska 111/II, 10000 Zagreb
    •	putem elektroničke komunikacije na adresu: hkms@hkms.hr; s nazivom elektroničke pošte: „Zahtjev za zaštitu osobnih podataka“
    •	putem telefaksa na broj: 01/2444306 uz naznaku „Zahtjev za zaštitu osobnih podataka“

    `;
  const textTitleBold = `
  Pisani zahtjev za zaštitu osobnih podataka mora sadržavati:`;
  const textRest = `
  •	naziv i sjedište tijela javne vlasti kojem se zahtjev podnosi;
  •	podatke koji su važni za prepoznavanje povrede zaštite osobnih podataka
  •	ime i prezime i adresu fizičke osobe podnositelja zahtjeva
  •	tvrtku odnosno naziv pravne osobe i njezino sjedište


  HRVATSKA KOMORA MEDICINSKIH SESTARA
    MAKSIMIRSKA 111/2
    10 000 ZAGREB

    Ovim putem potvrđujem kako sam upoznat/a s razlozima i svrhom prikupljanja mojih osobnih podataka od strane HKMS, pravima u pogledu obrade i zaštite osobnih podataka te kontakt podacima za podnošenje zahtjeva za zaštitu osobnih podataka

    Ovim putem potvrđujem kako pristajem na korištenje aplikacije eHKMSInfo te kako preuzimam osobnu odgovornost za točnost i potpunost unesenih podataka kao i za zaštitu pristupa i korištenja aplikacije.  

`;
  const textStyle = {
    whiteSpace: "pre-line",
  };
  const titleStyle = {
    whiteSpace: "pre-line",
    fontWeight: "bold",
  };
  const consentTextStyleScroll = {
    height: "500px",
    overflowY: "scroll",
    scrollbarColor: "#f4f3f3 rgba(201, 76, 76, 0.0)",
    scrollbarWidth: "thin",
  };

  const acceptBtnHandler = () => {
    POST(
      `${process.env.REACT_APP_GATEWAY_URL}/acceptConsent`,
      {},
      () => {
        window.location.reload();
      },
      (error) => {
        message.toggle({
          title: t("requests.overview.supplement.infoBar.errorTitle"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
  };

  const declineBtnHandler = () => {
    user.logout();
  };

  return (
    <div
      style={{ width: "100%", backgroundColor: "#f2f2f2" }}
      className=" display: flex flex is-justify-content-center is-align-self-center hero is-fullheight"
    >
      <div
        style={{ maxWidth: "1200px" }}
        className="card display: flex is-justify-content-center p-2 is-align-self-center mt-6 mb-6"
      >
        <div className="card-content is-flex is-justify-content-center">
          <div style={{ height: "50%" }} className="is-flex is-flex-direction-column p-2">
            <div style={consentTextStyleScroll}>
              <div className="is-align-self-center is-size-4" style={titleStyle}>
                {title}
              </div>
              <div style={textStyle}>{textStart}</div>
              <div className="is-size-4" style={titleStyle}>
                {textTitleBold}
              </div>
              <div style={textStyle}>{textRest}</div>
            </div>
            <button onClick={acceptBtnHandler} className="button is-info mt-4">
              Prihvaćam
            </button>
            <button onClick={declineBtnHandler} className="button is-info is-outlined mt-4">
              Odustajem
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Consent;
